import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";

export default class Driver {
    // takes the Vuex context.
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.fs = new Funnel({ ctx: lib.ctx });
    }


    synchMaritalStatus(e, input) {
        const uid = 'in_marital_status';
        let mStatus = '';
        if (e.target.value == 'Spouse')
            mStatus = 'Married';

        if (e.target.value == 'Domestic Partner')
            mStatus = 'Domestic Partner';

        const opts = this.getRelationshipToInsuredOptions();
        if (mStatus != '' && opts.indexOf(mStatus) != -1)
            this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: mStatus });
    }

    getRelationshipToInsuredOptions() {
        var validOpts = [];
        const opts = this.ctx.getters.funnel.elements['in_marital_status'].options;
        for (const i in opts) {
            if (!Utils.isEmpty(opts[i].value))
                validOpts.push(opts[i].value);
        }
        return validOpts;
    }

    processLicenseStatus(e, input) {
        console.log('driver-service: processLicenseStatus.');
        const uid = 'in_drv_has_valid_license';
        const val = input.value == 'Valid';
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: val });
    }

    processCurrentLicenseStateDependancies(e, input) {
        const uid = 'in_license_number';
        const userState = this.ctx.getters.funnel.elements['in_address_state'].value;
        if (userState == 'MA') {
            const ln = this.ctx.getters.funnel.elements[uid].value;
            let elem = {};
            if (userState == 'MA' && e.target.value != userState) {
                elem[uid] = Object.assign({}, this.ctx.getters.factory.initElements[uid]);
            } else if (e.target.value == 'MA') {
                elem[uid] = Object.assign({}, this.ctx.getters.factory.driverDF.driver[uid]);
            }
            elem[uid]['value'] = ln;
            this.ctx.commit('ADD_ELEMENTS', elem);
        }
    }

    addDriver(e, input) {
        if (this.ctx.getters.factory.saving != true) {
            console.log('driver-service: addDriver.');
            let resetLoader = false;
            if (this.processDriverMaxLimit(false)) {
                resetLoader = true;
            } else {
                if (this.validateDrivers()) {
                    this.ctx.dispatch('createDriverElem', { payload: {} });
                } else {
                    resetLoader = true;
                }
            }
            if (resetLoader)
                this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_new_driver', key: 'loading', val: false });
        }
    }

    driverActionBtns(e, input) {
        const func = (e.type == 'change') ? e.target.value.toLowerCase() : e.target.id;
        const fxn = `${func}Driver`;
        eval(`this.${fxn}(e, input)`);
    }

    editDriver(e, elem) {
        if (this.ctx.getters.factory.saving != true) {
            const uid = 'in_drv_opType';
            const elems = this.ctx.getters.funnel.elements;
            let dOpType = '';
            if (!Utils.isObjEmpty(elems[uid]))
                dOpType = elems[uid].value;

            if (dOpType == '' || dOpType == 'edit') {
                const drvNo = elem.uid.split('_').pop();
                this.createDriverAdHocSeq(drvNo);
                this.processDriverMaxLimit();
                this.ctx.dispatch('editDriverElem', { payload: elem });
            }
        }
    }

    createDriverAdHocSeq(ctxDrvNo) {
        const puid = `pg_drivers_start_${ctxDrvNo}`;
        const srcPuid = 'pg_drivers_summary';

        const srcPage = {
            'puid': srcPuid,
            'route': this.ctx.getters.funnel.elements[srcPuid].page_route
        };
        var pagesObj = {};
        pagesObj[puid] = this.ctx.getters.funnel.elements[puid].page_route;

        this.fs.createAdHocSeq(srcPage, pagesObj);
    }

    deleteDriver(e, elem) {
        if (this.ctx.getters.factory.saving != true) {
            console.log('Deleting driver.');
            this.processDriverMaxLimit();
            this.ctx.dispatch('deleteDriverElem', { payload: elem });
        }
    }

    keepDriver(e, elem) {
        var opts = this.ctx.getters.funnel.elements['in_primary_driver_prefill_select']['options'].slice();

        var opt = {};
        opt[elem.element_name] = `${elem.data.first_name} ${elem.data.last_name}`;
        const selectedOption = Utils.buildSelectOptions(opt, false, true, true);
        const newOpts = opts.concat(selectedOption);

        this.processKeptDriverCount(newOpts);
    }

    removeDriver(e, elem) {
        const opts = this.ctx.getters.funnel.elements['in_primary_driver_prefill_select']['options'];

        if (opts.length > 1) {
            var newOpts = [];
            for (const opt of opts) {
                if (opt.value != elem.element_name)
                    newOpts.push(opt);
            }

            this.processKeptDriverCount(newOpts);
        }
    }

    validateDrivers() {
        const drivers = this.getDriverElems();
        var isValid = false;
        var inValidDrvs = [];
        var drv = {};
        for (const uid of drivers) {
            Object.assign(drv, this.ctx.getters.funnel.elements[uid]);
            drv.id = `${drv.id}-id`;
            if (!this.fs.isValid(drv)) {
                inValidDrvs.push(uid);
            }
        }
        isValid = inValidDrvs.length == 0;
        return isValid;
    }

    getDriverElems() {
        const inSeqLen = this.fs.getPageInputSeqBySuid('pg_drivers_summary', 'sc_drivers_summary');
        return inSeqLen.filter(this.fs.checkStrMatch, { ctrl: 'in_driver_' });
    }

    getDriversCount() {
        let drvsCount = 0;
        const drvMatches = this.getDriverElems();
        if (drvMatches) {
            drvsCount = drvMatches.length;
        }
        console.log('No. of Drvs:', drvsCount);
        return drvsCount;
    }

    startDriverPrefill(e, input) {
        //e.preventDefault();
        console.log('Event obj is:', e);
        console.log('FormInput ...', input);
        //this.ctx.dispatch('processDriverPrefill');
    }

    countDriverPrefillOptions(opts = '', offset = 2) {
        if (Utils.isEmpty(opts))
            opts = this.ctx.getters.funnel.elements['in_primary_driver_prefill_select']['options'];
        let count = 0;
        if (opts.length > 0) {
            count = opts.length - offset;
        }
        return { count, opts };
    }

    processKeptDriverCount(newOpts) {
        const elem = this.ctx.getters.funnel.elements['in_driver_prefill_match'];
        let decr = 0;
        let offset = 0;
        if (Utils.isEmpty(elem.value)) {
            decr = 0;
            offset = 1;
        }
        const drvPrfl = this.countDriverPrefillOptions(newOpts, offset);
        const count = drvPrfl.count - decr;

        this.processDriverMaxLimit(false, count);

        const uid = 'in_primary_driver_prefill_select';
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_kept_driver_count', key: 'value', val: `${count}` });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'options', val: drvPrfl.opts });
        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: '' });
    }

    processPrefillDriverMaxLimit(e, elem) {
        const drvPrfl = this.countDriverPrefillOptions();
        let count = drvPrfl.count;
        if (!Utils.isEmpty(elem.value) && elem.value != 'none') {
            count--;
        }
        this.processDriverMaxLimit(false, count);
    }

    processDriverMaxLimit(rst = true, drvCount = this.getDriversCount()) {
        let isDrvMxLim = false;
        const uid = 'in_is_driver_max_limit_reached';
        const dmlr = this.ctx.getters.funnel.elements[uid];
        if (Utils.isObjEmpty(dmlr)) {
            return isDrvMxLim;
        }
        if (drvCount >= dmlr.data.max) {
            isDrvMxLim = true;
        }
        isDrvMxLim = rst && isDrvMxLim ? !rst : isDrvMxLim;

        this.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: uid, key: 'value', val: isDrvMxLim });
        return isDrvMxLim;
    }

    pg_drivers_start(payload) {
        const uid = 'in_occupation';
        if (!Utils.isObjEmpty(payload[uid])) {
            payload[uid]['options'] = this.ctx.getters.funnel.elements[uid]['options'];
        }

        this.fs.showTwinButtonCardLoader('driver', payload['in_drv_no'].value);
    }

    pg_drivers_prefill(payload) {
        console.log('BL for pg_drivers_prefill: ', payload);
    }

    pg_drivers_summary(payload) {
        console.log('BL for pg_drivers_summary: ', payload);
        const elem = this.ctx.getters.funnel.elements['in_vin_fetch_matches'];
        if (!Utils.isEmpty(elem) && elem.value == 'fetch_failed')
            this.ctx.commit('UPDATE_FACTORY_ITEMS', { disable_next: true });
    }

    update(e, input) {
        console.log('BL for driver input: ', payload);
    }

    drvPropStr(vfield) {
        return `in_${vfield}`;
    }

}
